module.exports = __webpack_public_path__ + "img/TZS09679.1542b92e.jpeg";